export const divVariants = {
  hidden: {},
  visible: {},
  exit: {}
};

// entry: fadeIn
export const fadeInVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
};
// entry: fadeIn || exit: fadeOut
export const fadeVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 }
};

// entry: fadeIn || exit: bounceOutLeft
export const fade_bounce_delay_variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.7
    }
  },
  exit: { x: "-100vw" }
};

// entry: bounceInRight || exit: bounceOutLeft
export const bounce_right_to_left_variants = {
  hidden: { x: "100vw" },
  visible: { x: 0 },
  exit: {
    x: "-100vw",
    transition: {
      when: "afterChildren"
    }
  }
};

// entry: bounceInRight || exit: bounceOutLeft
export const bounce_right_to_left_variants_entry = {
  hidden: { x: "100vw" },
  visible: {
    x: 0,
    transition: {
      when: "beforeChildren"
    }
  },
  exit: { x: "-100vw" }
};

// entry: bounceInRight || exit: bounceOutLeft
export const bounce_right_to_left_variants_without_children = {
  hidden: { x: "100vw" },
  visible: { x: 0 },
  exit: { x: "-100vw" }
};

// entry: bounceInRight || exit: bounceOutLeft
export const bounce_right_to_left_variants_delay = {
  hidden: { x: "100vw" },
  visible: {
    x: 0,
    transition: {
      x: { delay: 0.1 }
    }
  },
  exit: {
    x: "-100vw",
    transition: {
      when: "afterChildren",
      x: { delay: 0.1 }
    }
  }
};
// entry: bounceInRight || exit: flipOutX
export const bounce_right_to_left_variants_delay_flip_out_x = {
  
  hidden: { x: "100vw", opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 10
    }
  },
  exit: {
    opacity: 0,
    rotateX: -90,
    transition: {
      duration: 1.5,
      ease: "easeInOut",
    },
  },
};


//entry: flipinX  animation direction:reversed || exit: bounceOutLeft 

export const flipinX_entry_flipinX_reversed_exit_bounceOutLeft = {
  hidden: { 
    rotateX: -90, 
    opacity: 0,  
  },
  visible: {
    rotateX: 0,
    opacity: 1,
    transition: {
      duration: 0.8, 
    },
  },
  exit: {
    rotateX: 90, // Rotate to a flipped state again when exiting
    opacity: 0,
    transition: {
      duration: 0.8,
    },
  },
};




// entry: bounceInRight
export const bounce_entry_right_variants = {
  hidden: { x: "100vw" },
  visible: { x: 0 }
};

// exit: bounceOutLeft
export const bounce_exit_left_variants = {
  exit: { x: "-100vw" }
};

export const slideVariants = {
  hidden: { y: "50vh" },
  visible: {
    y: 0,
    transition: {
      bounce: 0,
      duration: 0.4
    }
  },
  exit: { y: "50vh" }
};

// entry: bounceInUp || exit: bounceOutUp
export const slide_bounce_variants = {
  hidden: { y: "100vh" },
  visible: {
    y: 0,
    transition: {
      type: "spring",
      duration: 0.4
    }
  },
  exit: { y: "-100vh" }
};

// entry: bounceInUp || exit: bounceOutDown
export const slide_bounce_down_variants = {
  hidden: { y: "100vh" },
  visible: {
    y: 0,
    transition: {
      type: "spring",
      duration: 0.4
    }
  },
  exit: { y: "100vh" }
};

// entry: bounceInDown || exit: bounceOutUp
export const slide_bounce_up_variants = {
  hidden: { y: "-100vh" },
  visible: {
    y: 0,
    transition: {
      type: "spring",
      duration: 0.8
    }
  },
  exit: { y: "-100vh" }
};

// entry: bounceInUp
export const slide_bounce_entry_variants = {
  hidden: { y: "100vh" },
  visible: {
    y: 0,
    transition: {
      type: "spring",
      duration: 0.4
    }
  }
};
// exit: bounceOutDown
export const slide_bounce_exit_variants = {
  exit: { y: "-100vh" }
};

export const modalSlideVariants = {
  hidden: { y: "100vh" },
  visible: {
    y: 0,
    transition: {
      bounce: 0,
      when: "beforeChildren"
    }
  },
  exit: { y: "100vh" }
};

// entry: bounceIn || exit: bounceOut
export const staticBounceVariants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    opacity: 1,
    scale: [0.3, 1.15, 0.85, 1.1, 1],
    transition: { duration: 0.7 }
  },
  exit: {
    scale: [0.95, 0.85, 1.1, 0.2]
  }
};

// entry: backInDown || exit: backOutUp
export const logoVariants = {
  hidden: {
    y: "-100vh",
    opacity: 0.5,
    scale: 0.7
  },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: {
      type: "tween",
      duration: 0.2,
      opacity: { delay: 0.2, duration: 0.3 },
      scale: { delay: 0.2, duration: 0.3 }
    }
  },
  exit: {
    y: "-100vh",
    opacity: 0.5,
    scale: 0.7,
    transition: {
      type: "tween",
      duration: 0.5,
      opacity: { duration: 0.3 },
      scale: { duration: 0.3 },
      y: { delay: 0.3 }
    }
  }
};

// entry: backInDown
export const logoEntryVariants = {
  hidden: {
    y: "-100vh",
    opacity: 0.5,
    scale: 0.7
  },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: {
      type: "tween",
      duration: 0.2,
      opacity: { delay: 0.2, duration: 0.3 },
      scale: { delay: 0.2, duration: 0.3 }
    }
  }
};

// exit: backOutUp
export const logoExitVariants = {
  exit: {
    y: "-100vh",
    opacity: 0.5,
    scale: 0.7,
    transition: {
      type: "tween",
      duration: 0.5,
      opacity: { duration: 0.3 },
      scale: { duration: 0.3 },
      y: { delay: 0.3 }
    }
  }
};
